export default __webpack_public_path__ + "media/images/package_pro-3f8752b35d1944df04fe0c273275b363.png";